import { useState, useMemo } from "react"
import { ApiPerformanceData } from "./types"

export const useSearch = (data: ApiPerformanceData[]) => {
  const [searchTerm, setSearchTerm] = useState<string>("")

  const filteredData = useMemo(() => {
    if (!searchTerm.trim()) {
      return data
    }

    const lowerSearchTerm = searchTerm.toLowerCase()

    return data.filter((item) => {
      // Search in product
      if (item.product?.toLowerCase().includes(lowerSearchTerm)) return true

      // Search in service
      if (item.service?.toLowerCase().includes(lowerSearchTerm)) return true

      // Search in region
      if (item.region?.toLowerCase().includes(lowerSearchTerm)) return true

      // Search in numeric values (converted to string)
      if (item.uptime.toString().includes(lowerSearchTerm)) return true
      if (item.avgResponseTime.toString().includes(lowerSearchTerm)) return true
      if (item.errorRate.toString().includes(lowerSearchTerm)) return true
      if (item.avgDbResponseTime?.toString().includes(lowerSearchTerm)) return true

      return false
    })
  }, [data, searchTerm])

  const clearSearch = () => {
    setSearchTerm("")
  }

  return {
    searchTerm,
    setSearchTerm,
    filteredData,
    clearSearch,
    hasActiveSearch: searchTerm.trim().length > 0
  }
}
